import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { cx } from '@paypalcorp/pp-react-utils';
import * as styles from './styles.css';
export { styles as screenReaderStyles };

var _excluded = ["as", "className", "children"];
var ScreenReader = function (_ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as,
    className = _ref.className,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(as, _extends({
    className: cx(styles.screenReader, className)
  }, rest, {
    "data-ppui": "true"
  }), children);
};

export { ScreenReader };
